import SelectivityDropdown from 'components/generic/SelectivityDropdown'
import { Button, Div, H2, Input, Label, Range, Number as NumberInput, Span, reactive } from 'alkali'
import { studyFilter, structuredQuery, hasCovid19 } from 'model/SearchQuery'
import app from '../../app/app'
import { ImportCollectionsSelector } from './ImportCollections'

export const StudyFilter = Div('.study-filter', [
	Div('#study-design.input-row', [
		SelectivityDropdown({
			placeholder: 'Study Design',
			multiple: true,
			value: studyFilter.designs,
			items: [
				{ id: 'RCT', text: 'Randomized Controlled Trial' },
				{ id: 'CS', text: 'Clinical Study' },
				{ id: 'RWE', text: 'Real-World Evidence' },
			],
		}),
	]),
	Div(
		'#study-source.input-row',
		reactive(app.user).to((user) => [
			SelectivityDropdown({
				placeholder: 'Study Source',
				value: studyFilter.sources.to(sources => sources.length > 0 ? sources :
					structuredQuery.characteristics.to(characteristics => {
						let sources = ['clinicaltrials', 'eu', 'medline', 'who-ictrp', 'medrxiv']
						if (user?.LegacyRoles?.includes('Congress'))
							sources.push('doc-congress')
						if (hasCovid19(characteristics))
							sources.push('cord19')
						return sources
					}), (sources) => {
						if (sources.length == 0)
							alert('All sources, reseting to no sources filtering')
						studyFilter.sources.put(sources)
					}),
				multiple: true,
				items: [
					{ id: 'clinicaltrials', text: 'ClinicalTrials.gov' },
					{ id: 'eu', text: 'EU Clinical Trials' },
					{ id: 'cord19', text: 'CORD-19' },
					{ id: 'medline', text: 'Pubmed' },
					{ id: 'who-ictrp', text: 'WHO ICTRP' },
					{ id: 'medrxiv', text: 'medRxiv' },
					...(user?.LegacyRoles?.includes('Congress')
						? [{ id: 'doc-congress', text: 'Congresses' }]
						: []),
				],
			}),
		])
	),
	Div('#study-imports.input-row', [ImportCollectionsSelector({})]),

	Label([
		Span('Publication Date: '),
		NumberInput('.publication-date-input', {
			min: 1950,
			max: 2030,
			content: studyFilter.published,
		}),
	]),
])
